// import { SvgIcon } from "@material-ui/core"
// import React from 'react';

import * as React from "react";

const ViewerUser = (props) => (
    <svg
        width={68}
        height={77}
        viewBox="0 0 68 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle
            cx={34}
            cy={34}
            r={33}
            fill="white"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={30} fill="#DBE5EE" />
        <path
            d="M55.5 55L53.5 57.5L47.5 62C49.5 56 39.4 50.4 39 50C38.6 49.6 37.5 46 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 42.8333 29.5 42.5 24.5C42.1667 24.5 38.6283 23.6597 35 23C29.5 22 29 13 29.5 11.5L37 11L45 13.5L49 20.5L51.5 34.5L52 48.5C52 48.5 48 49.1102 48 47.5C48 36 46 29 46 29L45.5 33.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z"
            fill="white"
        />
        <path
            d="M41 41.5C41.0001 43.5792 40.4496 47.7663 44.109 48.099C48.6833 48.5148 53.2574 48.099 54.505 55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M30.3861 18.8218C31.3841 24.8099 40.2035 24.2277 45.3201 23.396C45.6358 25.1383 45.7723 26.9752 45.7723 28.802C45.7723 36.6105 43.2773 42.9406 34.9604 42.9406C27.0595 42.9406 24.1486 36.6105 24.1486 28.802C24.1486 25.0161 24.7351 21.1868 26.2872 18.2461"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M27.4753 47.2673C27.4753 47.2673 29.1387 50.5941 34.9605 50.5941M42.4456 47.2673C42.4456 47.2673 40.7823 50.5941 34.9605 50.5941M34.9605 50.5941V55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M52 50C52 28.4609 51.15 11 35 11C18 11 18 28.4609 18 50"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={33} stroke="#333F50" strokeWidth={2} />
        <circle
            cx={35}
            cy={64}
            r={12}
            fill="#DBE4EE"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M46 64C46 70.0751 41.0751 75 35 75C35 75 41.2857 70.0751 41.2857 64C41.2857 57.9249 35 53 35 53C41.0751 53 46 57.9249 46 64Z"
            fill="white"
        />
        <path
            d="M44 64.5C44 64.5 39.9706 70 35 70C30.0294 70 26 64.5 26 64.5C26 64.5 30.0294 59 35 59C39.9706 59 44 64.5 44 64.5Z"
            fill="#333F50"
        />
        <circle
            cx={35}
            cy={65}
            r={2}
            fill="#DBE4EE"
            stroke="#DBE4EE"
            strokeWidth={2}
        />
    </svg>
);

export default ViewerUser;


// export default function ViewerUser(props) {
//     return (
//         <SvgIcon width="68" height="77" fill="none" viewBox="0 0 68 77" {...props} >
//             <circle cx="34" cy="34" r="33" fill="white" stroke="#333F50" strokeWidth="2" />
//             <circle cx="34" cy="34" r="30" fill="#DBE5EE" />
//             <path d="M55.5 55L53.5 57.5L47.5 62C49.5 56 39.4 50.4 39 50C38.6 49.6 37.5 46 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 42.8333 29.5 42.5 24.5C42.1667 24.5 38.6283 23.6597 35 23C29.5 22 29 13 29.5 11.5L37 11L45 13.5L49 20.5L51.5 34.5L52 48.5C52 48.5 48 49.1102 48 47.5C48 36 46 29 46 29L45.5 33.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z" fill="white" />
//             <path d="M41 41.5C41.0001 43.5792 40.4496 47.7663 44.109 48.099C48.6833 48.5148 53.2574 48.099 54.505 55.1683" stroke="#333F50" strokeWidth="2" />
//             <path d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56" stroke="#333F50" strokeWidth="2" />
//             <path d="M30.3861 18.8218C31.3841 24.8099 40.2035 24.2277 45.3201 23.396C45.6358 25.1383 45.7723 26.9752 45.7723 28.802C45.7723 36.6105 43.2773 42.9406 34.9604 42.9406C27.0595 42.9406 24.1486 36.6105 24.1486 28.802C24.1486 25.0161 24.7351 21.1868 26.2872 18.2461" fill="none" stroke="#333F50" strokeWidth="2" />
//             <path d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36" stroke="#333F50" strokeWidth="2" />
//             <path d="M27.4753 47.2673C27.4753 47.2673 29.1387 50.5941 34.9605 50.5941M42.4456 47.2673C42.4456 47.2673 40.7823 50.5941 34.9605 50.5941M34.9605 50.5941V55.1683" stroke="#333F50" strokeWidth="2" />
//             <path d="M52 50C52 28.4609 51.15 11 35 11C18 11 18 28.4609 18 50" fill="none" stroke="#333F50" strokeWidth="2" />
//             <circle cx="34" cy="34" r="33" stroke="#333F50" fill="none" strokeWidth="2" />
//             <circle cx="35" cy="64" r="12" fill="#DBE4EE" stroke="#333F50" strokeWidth="2" />
//             <path d="M46 64C46 70.0751 41.0751 75 35 75C35 75 41.2857 70.0751 41.2857 64C41.2857 57.9249 35 53 35 53C41.0751 53 46 57.9249 46 64Z" fill="white" />
//             <path d="M44 64.5C44 64.5 39.9706 70 35 70C30.0294 70 26 64.5 26 64.5C26 64.5 30.0294 59 35 59C39.9706 59 44 64.5 44 64.5Z" fill="#333F50" />
//             <circle cx="35" cy="65" r="2" fill="#DBE4EE" stroke="#DBE4EE" strokeWidth="2" />
//         </SvgIcon>
//     );
// }